( function () {
	'use strict';

	/* @ngInject */
	/* eslint-disable max-params */
	function PpdListCtrl ( $scope, ppdFactory, PPD_MESSAGES, apiService, edivateBaseUrl ) {
		var self = this;

		self.readOnly = ppdFactory.isReadOnly();

		function getIconType ( type ) {
			var icons = ppdFactory.setIcons();

			return icons[ type ];
		}

		function addPPD ( item ) {
			item.isAttached = true;

			$scope.$parent.$emit( 'ppd:add', item );
		}

		function removePPD ( item ) {
			delete item.isAttached;
			$scope.$parent.$emit( 'ppd:remove', item );
		}

		function addDueDate ( item ) {
			$scope.$parent.$emit( 'ppd:update', item );
		}

		function removeDueDate ( item ) {
			delete item.dueDate;
			$scope.$parent.$emit( 'ppd:update', item );
		}

		function fetchMCDetails ( item ) {
			apiService.mc.get( item.id )
				.then( function ( mc ) {
					item.meta = mc.data.meta;
					ppdFactory.updateData( item );
				} );
		}

		self.getIconType    = getIconType;
		self.ppdMessages    = PPD_MESSAGES;
		self.minimumDate    = new Date();
		self.addPPD         = addPPD;
		self.removePPD      = removePPD;
		self.addDueDate     = addDueDate;
		self.removeDueDate  = removeDueDate;
		self.parentScope    = $scope.$parent;
		self.location       = ppdFactory.getLocation();
		self.viewDisabled   = ppdFactory.isViewDisabled();
		self.fetchMCDetails = fetchMCDetails;
		self.edivateBaseUrl = edivateBaseUrl;
	}

	angular
		.module( 'app.components' )
		.controller( 'PpdListCtrl', PpdListCtrl );

	PpdListCtrl.$inject = [ '$scope', 'ppdFactory', 'PPD_MESSAGES', 'apiService', 'edivateBaseUrl' ];
} )( );
